export const locale = {
    lang: 'en',
    data: {
        'NAV': {
            'APPLICATIONS': 'Menu',
            'SAMPLE'        : {
                'TITLE': 'Dashboard',
                'BADGE': '25'
            }
        }
    }
};
